<template>
  <v-timeline
    v-if="items.length > 0"
    :dense="$vuetify.breakpoint.smAndDown"
    class="timeline__wrapper"
  >
    <v-timeline-item left color="warning" icon class="text-right">
      <template slot="icon">
        <v-icon x-large class="white--text">mdi-information-outline</v-icon>
      </template>
      <span slot="opposite" v-if="selectedTicket">
        <v-chip>
          <v-icon color="success">access_time </v-icon>
          {{ moment(selectedTicket.date_creation).format("DD/MM/YYYY  HH:mm") }}
        </v-chip>
      </span>
      <div style="width: 100%" class="d-flex justify-end">
        <div
          class="ma-2 success--text text-justify incident description pb-2 pt-2"
          color="success"
          outlined
          x-large
        >
          Déclaration d'intervention:
          <div
            v-if="selectedTicket.content"
            v-html="decodeContent(selectedTicket.content)"
          ></div>
        </div>
      </div>
    </v-timeline-item>
    <v-timeline-item
      v-for="(item, i) in items"
      :key="i"
      :color="item.color"
      :left="!item.actionType || item.actionType === 3"
      :right="!!item.actionType"
      icon
      fill-dot
    >
      <template v-slot:icon>
        <v-avatar>
          <span v-if="!item.actionType" class="white--text">{{
            getAvatarName(item.user_name)
          }}</span>
          <v-icon v-else dark>mdi-account-circle</v-icon>
        </v-avatar>
      </template>
      <span slot="opposite">
        <v-chip small>
          <v-icon :left="!item.actionType" :color="item.color"
            >access_time</v-icon
          >
          {{ moment(item.date_creation).format("DD/MM/YYYY  HH:mm") }}
        </v-chip>
      </span>
      <v-card :color="item.color" dark shaped raised>
        <v-card-title class="pa-0 pa-md-1 pl-3">{{
          item.user_name
        }}</v-card-title>
        <v-card-text class="white text--primary">
          <task-item :item="item" v-if="item.actionType === 2"></task-item>
          <v-row v-else-if="item.actionType === 3">
            <image-item :item="item"></image-item>
          </v-row>
          <div
            v-else
            class="incident"
            v-html="decodeContent(item.content)"
          ></div>
        </v-card-text>
      </v-card>
    </v-timeline-item>
    <v-timeline-item right color="primary" icon>
      <template slot="icon">
        <v-icon x-large class="white--text">mdi-information-outline</v-icon>
      </template>

      <span slot="opposite" v-if="selectedTicket">
        <v-chip>
          <v-icon color="success">access_time </v-icon>
          {{ moment().format("DD/MM/YYYY HH:mm") }}
        </v-chip>
      </span>
      <v-chip class="ma-2" color="success" outlined>
        Maintenant
      </v-chip>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { Decoder } from "../mixins/decodeContent";
import { getColor, getAvatarName } from "../utils";
import moment from "../plugins/moment";
import ImageItem from "./timeline/ImageItem";
import TaskItem from "./timeline/TaskItem";
import USER_API from "../api/user";

export default {
  name: "TimeLine",
  components: { TaskItem, ImageItem },
  props: {
    list: {
      type: Array,
      required: true
    },
    selectedTicket: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      items: [],
      users: []
    };
  },
  mixins: [Decoder],
  methods: {
    getColor,
    getAvatarName,
    moment,
    async loadUserName() {
      this.items.forEach(async (el, index) => {
        const ticket = el;
        const user = this.users.findIndex(u => {
          return u.id === el.users_id;
        });
        if (user > -1) {
          const data = this.users[user];
          const userName =
            data.firstname || data.realname
              ? `${data.firstname} ${data.realname}`
              : data.name;
          const ticket = el;
          ticket.user_name = userName ? userName : "...";
          this.$set(this.items, index, ticket);
        } else {
          ticket.user_name = "...";
          await USER_API.getUserData(el.users_id).then(({ data }) => {
            this.users.push(data);
            const userName =
              data.firstname || data.realname
                ? `${data.firstname} ${data.realname}`
                : data.name;
            const ticket = el;
            ticket.user_name = userName ? userName : "...";
            this.$set(this.items, index, ticket);
          });
        }
      });
    }
  },
  mounted() {
    this.items = this.list.map(el => {
      el.user_name = "...";
      return el;
    });
    this.loadUserName();
  },
  watch: {
    list() {
      this.$nextTick(() => {
        this.items = this.list.map(el => {
          el.user_name = "...";
          return el;
        });
        this.loadUserName();
      });
    }
  }
};
</script>

<style>
.timeline__wrapper .description {
  border: 1px solid #0072ce;
  border-radius: 16px;
  background-color: transparent !important;
  margin: 8px !important;
  font-size: 14px;
  border-width: thin;
  line-height: 20px;
  outline: none;
  overflow: auto;
  padding: 0 12px;
  position: relative;
  text-decoration: none;
  transition-duration: 0.28s;
  transition-property: opacity, -webkit-box-shadow;
  transition-property: box-shadow, opacity;
  transition-property: box-shadow, opacity, -webkit-box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  white-space: nowrap;
  max-height: 250px;
}
</style>
